import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionDecryptionService {

  constructor() { }

  // Ecrypt Data
  encryptedPassword(passwordParams):any {
          const key = CryptoJS.enc.Utf8.parse('b914741dca31bfae4c2d4d003780b00e');
          const iv = CryptoJS.enc.Utf8.parse('YblSonSheNeebal6');
          const cryptoEncryptedPassword = CryptoJS.AES.encrypt(
              passwordParams,
              key,
              { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
          ).toString();
          return cryptoEncryptedPassword;
  }


  // Decrypt Data
  decryptedData(passwordParams):any  {
    const key = CryptoJS.enc.Utf8.parse('b914741dca31bfae4c2d4d003780b00e');
    const iv = CryptoJS.enc.Utf8.parse('YblSonSheNeebal6');
    const cryptoDecryptedData = CryptoJS.AES.decrypt(
                        passwordParams, key, {iv:iv, padding: CryptoJS.pad.Pkcs7}).
                        toString(CryptoJS.enc.Utf8);
    return cryptoDecryptedData;  
  } 

}
